module.exports = __webpack_public_path__ + "static/media/search.4d249f68.svg";